import { inject, Injectable, signal } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { getClerkRegisterProbateFormControls } from './constants';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { map, tap } from 'rxjs';

@Injectable()
export class RegisterProbateFormService {
  private readonly _fb = inject(NonNullableFormBuilder);

  private readonly _isLoading = signal(false);

  public readonly isLoading = this._isLoading.asReadonly();

  public setIsLoading(isLoading: boolean): void {
    this._isLoading.set(isLoading);
  }

  public readonly registerForm = this._fb.group(
    getClerkRegisterProbateFormControls(this._fb),
  );

  public readonly isFirm = toSignal(
    this.registerForm.controls.isFirm.valueChanges.pipe(
      map((isFirm) => !!isFirm),
    ),
    {
      initialValue: false,
    },
  );

  constructor() {
    this.registerForm.controls.isFirm.valueChanges
      .pipe(
        tap((isFirm: boolean) => {
          if (isFirm) {
            this.registerForm.controls.lastName.disable();
            this.registerForm.controls.middleName.disable();

            this.registerForm.controls.lastName.setValue('');
            this.registerForm.controls.middleName.setValue('');
          } else {
            this.registerForm.controls.lastName.enable();
            this.registerForm.controls.middleName.enable();
          }
          this.registerForm.updateValueAndValidity();
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }
}
